// extracted by css-extract-rspack-plugin
export default {"root":"Badge-module__root___EyD2R","section":"Badge-module__section___eWXjs"};